<template>
    <div class="card-box p-0 over_hide">
        <div class="header_items_dash">
            <div class="w_full">
                <h4 class="header-title m-t-0 m-b-4 text-dark t_overflow">{{ $t('pending_tasks') }}</h4>
                <button @click.prevent="show('overdue')"  class="btn btn-danger btn-xs f_size_11 text-lowercase">{{overdue}} {{ $t('p_overdue') }}</button>
                <button @click.prevent="show('pending')"  class="btn btn-warning btn-xs f_size_11 text-lowercase">{{pending}} {{ $t('p_pending') }}</button>
            </div>
            <button @click.prevent="show('all')" class="btn btn-white btn-sm">{{ $t("show_all") }}</button>
        </div>
        <ul class="list_items_dash">
            <router-link v-for="item in list" tag="li" :to="`/deals/${item.deal.id}/tasks`" :key="item.id">
                <div class="photo_lead">
                    <img :src="item.deal.lead.avatar || '/static/images/avatar.jpg'" title="Nome do Lead" class="img-circle thumb-sm">
                </div>
                <div class="w_full">
                    <div class="m-b-5">
                        <small class="bold text-muted">{{ item.due_date_at | pmlDate('DD/MM/YYYY HH:mm') }}</small>
                        <span class="label pull-right" :style="`background-color: ${$options.filters.pmlAccessWayById(item.access_way_id, 'color')}`">{{item.access_way_id | pmlAccessWayById('name')}}</span>
                    </div>
                    <div class="d_flex">
                        <p class="m-0 f_size_13 c_default w_full">
                            <strong>#{{item.deal.code}}<span v-if="item.deal.lead.full_name !== item.deal.lead.email"> - {{item.deal.lead.full_name}}</span></strong>
                            <small class="t_overflow m-b-5 show text-muted" v-if="item.deal.lead.reference">({{item.deal.lead.reference}})</small>
                        </p>
                        <div class="min_max_w_20 text-right">
                            <span v-pml-tooltip.left="$t(isAfter(item.due_date_at) ? 'overdue' : 'pending')"><i :class="`f_size_10 fa fa-circle text-${isAfter(item.due_date_at) ? 'danger' : 'warning'} m-0`"></i></span>
                        </div>
                    </div>
                    <div class="d_flex">
                        <p class="w_full t_overflow f_size_12 m-0">
                            {{item.title}}
                        </p>
                    </div>
                </div>
            </router-link>
            <PmlInfiniteLoading @infinite="infiniteHandler($event)" ref="infiniteLoading" spinner="wavedots">
                <span slot="no-more"></span>
                <span slot="no-results"></span>
                <span v-if="list.length === total && !isLoading" slot="spinner"></span>
            </PmlInfiniteLoading>
            <router-link :to="{ name: 'calendar.create' }" tag="li" class="null_item"  v-if="!list.length && !isLoading">
                <div class="clearfix text-center">
                    <div class="icon_svg m-b-10">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><path d="M494.345,485.517H17.655C7.904,485.517,0,477.613,0,467.862V61.793 c0-9.751,7.904-17.655,17.655-17.655h476.69c9.751,0,17.655,7.904,17.655,17.655v406.069 C512,477.612,504.095,485.517,494.345,485.517z" style="fill: rgb(228, 234, 246);"></path> <path d="M512,132.414H0V61.793c0-9.751,7.904-17.655,17.655-17.655h476.69 c9.751,0,17.655,7.904,17.655,17.655V132.414z" style="fill: rgb(199, 207, 226);"></path> <rect y="132.414" width="512" height="17.655" style="fill: rgb(228, 234, 246);"></rect> <circle cx="75.034" cy="83.862" r="26.483" style="fill: rgb(152, 159, 182);"></circle> <path d="M75.034,97.103L75.034,97.103c-7.313,0-13.241-5.929-13.241-13.241V39.724 c0-7.313,5.929-13.241,13.241-13.241l0,0c7.313,0,13.241,5.929,13.241,13.241v44.138C88.276,91.175,82.347,97.103,75.034,97.103z" style="fill: rgb(199, 207, 226);"></path> <path d="M75.034,70.621c-7.313,0-13.241-5.929-13.241-13.241v26.483c0,7.313,5.929,13.241,13.241,13.241 c7.313,0,13.241-5.929,13.241-13.241V57.379C88.276,64.692,82.347,70.621,75.034,70.621z" style="fill: rgb(175, 185, 210);"></path> <circle cx="436.966" cy="83.862" r="26.483" style="fill: rgb(157, 165, 187);"></circle> <path d="M436.966,97.103L436.966,97.103c-7.313,0-13.241-5.929-13.241-13.241V39.724 c0-7.313,5.929-13.241,13.241-13.241l0,0c7.313,0,13.241,5.929,13.241,13.241v44.138C450.207,91.175,444.278,97.103,436.966,97.103z " style="fill: rgb(199, 207, 226);"></path> <path d="M436.966,70.621c-7.313,0-13.241-5.929-13.241-13.241v26.483c0,7.313,5.929,13.241,13.241,13.241 s13.241-5.929,13.241-13.241V57.379C450.207,64.692,444.278,70.621,436.966,70.621z" style="fill: rgb(175, 185, 210);"></path> <g><path d="M235.092,311.389c-0.951-0.22-1.045-1.433-0.135-1.786c20.881-8.087,33.37-25.999,33.37-49.023 c0-32.557-28.322-56.185-67.334-56.185c-33.768,0-59.531,17.66-67.238,46.091c-0.99,3.628-0.249,7.412,2.019,10.377 c2.22,2.904,5.59,4.569,9.242,4.569c5.284,0,9.918-3.616,11.261-8.796c4.851-18.826,21.645-30.518,43.83-30.518 c26.649,0,43.862,14.507,43.862,36.957c0,22.711-18.396,38.573-44.732,38.573h-16.143c-5.832,0-10.57,4.738-10.57,10.566 c0,5.827,4.738,10.57,10.57,10.57h17.013c33.068,0,52.807,15.46,52.807,41.357c0,23.797-21.405,41.067-50.901,41.067 c-25.442,0-45.133-12.395-50.168-31.584c-1.408-5.325-6.098-9.045-11.406-9.045c-3.651,0-7.022,1.657-9.267,4.545 c-2.284,2.952-3.057,6.737-2.115,10.38c7.448,28.809,36.14,47.422,73.101,47.422c42.905,0,75.257-27.244,75.257-63.372 C277.417,336.879,261.187,317.42,235.092,311.389z" style="fill: rgb(149, 155, 179);"></path> <path d="M361.297,207.48c-5.944,0.022-11.662,1.794-16.546,5.132c-6.177,4.215-15.17,10.465-23.874,16.514 c-8.687,6.033-17.077,11.864-22.072,15.258c-3.025,2.059-4.834,5.465-4.834,9.113c0,4.103,2.252,7.839,5.871,9.757 c3.644,1.939,7.883,1.709,11.309-0.623c8.813-5.99,32.358-22.553,38.626-26.967c0.666-0.47,1.551,0.032,1.551,0.847v175.306 c0,6.472,5.269,11.736,11.736,11.736c6.467,0,11.736-5.265,11.736-11.736v-190.95C374.802,213.444,368.721,207.453,361.297,207.48z " style="fill: rgb(149, 155, 179);"></path></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g> <g></g></svg>
                    </div>
                    <small class="show m-b-5">{{ $t('no_task_found') }}</small>
                    <p class="bold m-0 c_blue">{{ $t('create_a_task') }}</p>
                </div>
            </router-link>
        </ul>
    </div>
</template>

<script>
    import { getTasksReport } from '@/services/reports'
    import { mapGetters } from 'vuex'
    import PmlInfiniteLoading from 'vue-infinite-loading'
    import moment from 'moment'
    import { utcToLocal } from '@/utils/helpers/dates.js'
    import bus from '@/utils/events/bus'

    export default {
        name: 'NextTasks',
        components: {
            PmlInfiniteLoading
        },
        data () {
            return {
                isLoading: true,
                list: [],
                page: 0,
                total: 0,
                overdue: 0,
                pending: 0
            }
        },
        computed: {
            ...mapGetters({
                'member': 'getMember'
            })
        },
        created () {
            this.getCount()
            bus.$on('refreshTasksCard', this.clearInfinity)
        },
        methods: {
            getTasksReport ($state) {
                this.isLoading = true
                getTasksReport({
                    member_id: this.member.id,
                    status: 'pending',
                    page: this.page + 1,
                    orderBy: 'due_date_at',
                    report_type: 'consultant_table'
                })
                    .then((response) => {
                        this.list.push(...response.data.data)
                        this.total = response.data.total
                        this.page = response.data.current_page

                        $state.loaded()
                        if (this.list.length === this.total)
                            $state.complete()
                    })
                    .then(() => { this.isLoading = false })
            },
            infiniteHandler ($state) {
                setTimeout(() => {
                    this.getTasksReport($state)
                }, 1000)
            },
            isAfter (dueDate) {
                return moment().isAfter(utcToLocal(dueDate))
            },
            show (status) {
                window.localStorage.setItem('pml_reports_tasks_show', status)
                window.localStorage.setItem('pml_reports_tasks_status_s', 'pending')
                window.localStorage.setItem('pml_reports_tasks_due_date_at_from', null)
                window.localStorage.setItem('pml_reports_tasks_due_date_at_to', null)
                this.$router.push({ name: 'tasks.show' })
            },
            getCount () {
                getTasksReport({
                    member_id: this.member.id,
                    status: 'pending',
                    select: ['due_date_at']
                })
                    .then((response) => {
                        this.overdue = response.data.filter(({due_date_at}) => this.isAfter(due_date_at)).length
                        this.pending = response.data.length - this.overdue
                    })
            },
            clearInfinity () {
                this.isLoading = true
                this.list = []
                this.page = 0
                this.total = 0
                this.$nextTick(() => {
                    if (typeof this.$refs['infiniteLoading'] !== 'undefined')
                        this.$refs['infiniteLoading'].$emit('$InfiniteLoading:reset')
                })
                this.getCount()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/dashboard/components/widgets/OpenTasks.vue